/// Types
/// Components
import { useSelector } from 'react-redux';
/// Slices
import { reservationTemplatesSelector } from 'slices/reservationTemplate.slice';
import type { TFieldRelation } from '@timeedit/types/lib/types';
import { Label, TEDrawerSection, TEInput } from '@timeedit/ui-components';
/// Styles
import './FieldRelationReservationTemplate.scss';

interface FieldRelationReservationTemplateProps {
  fieldRelation: TFieldRelation;
  onChange: (key: string, value: any) => void;
}

const FieldRelationReservationTemplate = (
  props: FieldRelationReservationTemplateProps
) => {
  const { fieldRelation, onChange } = props;
  const reservationTemplates = useSelector(reservationTemplatesSelector);
  const reservationTemplateOptions = reservationTemplates.map((template) => ({
    value: String(template.id),
    label: template.name,
  }));
  return (
    <div className="field-relation-reservation-template">
      <TEDrawerSection label="Reservation templates">
        <Label
          title="Select reservation templates where the field relation applies"
          tooltip="Select reservation templates"
          data-testid="reserv-template"
        />
        <div className="te-mt-2">
          <TEInput.Select
            mode="multiple"
            value={fieldRelation.reservationTemplates.map((val) => String(val))}
            onChange={(values) =>
              onChange(
                'reservationTemplates',
                values.map((value: string) => Number(value))
              )
            }
            options={reservationTemplateOptions}
            label=""
            size="middle"
            style={{ minWidth: '432px' }}
          />
        </div>
      </TEDrawerSection>
    </div>
  );
};

export default FieldRelationReservationTemplate;
